import React, {useEffect} from 'react'
import DefaultOutput from '../subcomponents/DefaultConsoleOutputs'
import useConsoleStore from '../../stores/ConsoleStore'

function Console() {
  const {outputs, switchChannel, fetchConsole, selectedChannel} = useConsoleStore()
  const console_btns = ['all', 'summary', 'trades', 'triggers', 'exec', 'error']

  const changeChannel = e => {
    e.preventDefault();
    const channel = e.target.name
    switchChannel(channel)
    fetchConsole()
  }
  // useEffect(()=>  {
  //   const fetchData = async () => {
  //       try {
  //           await fetchConsole()
  //       } catch (error) {
  //           console.log("Error fetching user settings", error);
  //       }
  //   }
  //   fetchData();
  // }, [])

  return (
    <div className='widget_body'>
      <div className="console_container">
          <div className="console_btn_container">
              {console_btns.map((btn) => {
                  return <button key={btn} name={btn} className={btn === selectedChannel ? "console_btn active_console btn no_drag" : "console_btn btn no_drag"} onClick={changeChannel}>{btn}</button>
              })}
          </div>                    
          { 
            (selectedChannel in outputs) ?  
            (<ul className="console_ul" id ='console_ul' key={selectedChannel + "console"}> {
                outputs[selectedChannel].map((alerts) => {
                    return <DefaultOutput key={JSON.stringify(alerts)} props={alerts}/>}
                    )} </ul>) : (
                        <ul></ul>
                    )
          }
      </div>
    </div>
  )
}

export default Console;